module.exports = __webpack_public_path__ + "img/phoneIcon.928a51be.svg";